import { Auditable, QueryParams, SortParams } from "..";

export interface TissueType extends Auditable {
    name: string;
    code: string;
    isResearch: boolean;
}

export const DefaultTissueTypeQueryParams: QueryParams = {
    name: "",
};

export const DefaultTissueTypeSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};

// default tissue types, compare to api/Resources/TissueTypes/DefaultTissueTypes.cs
// used for determining the post-procedure eval layout
export enum TissueTypes {
    Cairs = "CAIRS",
    Cairs1 = "CAIRS1",
    CairsCtr = "CAIRS Ctr",
    CairsSeg1 = "CAIRS Seg1",
    CairsSeg2 = "CAIRS Seg2",
    Cornea = "Cornea",
    Cornea1 = "Cornea1",
    Cornea2 = "Cornea2",
    CorneaFrill = "Cornea/Frill",
    Dmek = "DMEK",
    Lenticule = "Lenticule",
    Precut = "Precut",
    Precut1 = "Precut1",
    Precut2 = "Precut2",
    Quarter1 = "Quarter1",
    Quarter2 = "Quarter2",
    Quarter3 = "Quarter3",
    Quarter4 = "Quarter4",
    Remnant = "Remnant",
    Sclera = "Sclera",
    Sclera1 = "Sclera1",
    Sclera2 = "Sclera2",
    WholeGlobe = "Whole Globe",

    // research types
    Aqueous = "Aqueous",
    Conjunctiva = "Conjunctiva",
    Lens = "Lens",
    Pole = "Pole",
    Vitreous = "Vitreous",
}

export const corneaTissueTypes: string[] = [
    TissueTypes.Cornea,
    TissueTypes.Cornea1,
    TissueTypes.Cornea2,
    TissueTypes.CorneaFrill,
];

export const isCornea = (tissueType: string | undefined) => corneaTissueTypes.includes(tissueType ?? "");

export const scleraTissueTypes: string[] = [
    TissueTypes.Sclera,
    TissueTypes.Sclera1,
    TissueTypes.Sclera2,
    TissueTypes.Quarter1,
    TissueTypes.Quarter2,
    TissueTypes.Quarter3,
    TissueTypes.Quarter4,
];

export const isSclera = (tissueType: string | undefined) => scleraTissueTypes.includes(tissueType ?? "");

export const precutTissueTypes: string[] = [TissueTypes.Precut, TissueTypes.Precut1, TissueTypes.Precut2];

export const isPrecut = (tissueType: string | undefined) => precutTissueTypes.includes(tissueType ?? "");
